import { Button, IconButton, Tooltip } from "@mui/material"
import CardCollapse from "../../../components/CardActions"
import { ITableColumn, TableColumnType, TableList } from "src/components/table"

// import { columnsTablaWRMInstrumento } from "../../../data/dataWRMercado"
import { ICON_MAS } from "../../../components/SharedIcons"
import { useEffect, useState } from "react"
import { useInstrumentos } from "../hooks/useInstrumentos"
import { InstrumentoFields } from "../api/instrumento-fields"
import { Instrumento } from "../api/get-instrumentos"
import toast from "react-hot-toast"
import { HttpWRM } from "../api"
import { EntityWithIdFields, QueryStatus } from "src/types"
import DeleteIcon from '@mui/icons-material/Delete';
import { DialogNuevoInstrumento } from "./DialogNuevoInstrumento"
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog"

type SeccionWRMInstrumento = {
    idOperacion: number
    permiteEditar: boolean
    permiteEliminar: boolean
}

const SeccionWRMInstrumento = ({ idOperacion, permiteEditar, permiteEliminar }: SeccionWRMInstrumento) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    // TODO: corregir todos los imports con index
    const { status, instrumentos, refetch } = useInstrumentos(idOperacion)

    const { askConfirmation } = useConfirmationDialog();

    const columnsTablaWRMInstrumento: ITableColumn[] = [
        { label: 'Excepción', value: InstrumentoFields.Excepcion },
        { label: 'Instrumento', value: InstrumentoFields.Instrumento },
        { label: 'Límite', value: InstrumentoFields.DescOperacionLimiteTipo },
        { label: 'Valor nominal', value: InstrumentoFields.ValorNominal, type: TableColumnType.Decimal },
        { label: 'Cash value USD', value: InstrumentoFields.CashValueUSD, type: TableColumnType.Decimal },
        {
            label: 'Acciones', onRenderCell: (entity: Instrumento) => (
                <>
                    {
                        permiteEliminar &&
                        <Tooltip title='Eliminar'>
                            <IconButton onClick={
                                () => askConfirmation(
                                    () => {
                                        const promise = HttpWRM.deleteInstrumento(idOperacion, entity[EntityWithIdFields.Id])

                                        toast.promise(promise, {
                                            success: 'Eliminado',
                                            error: 'No se pudo eliminar',
                                            loading: 'Eliminando'
                                        }).then(() => refetch())
                                    }
                                )
                            }
                            >
                                <DeleteIcon color='error' />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            ),
            width: 0.1
        }
    ]

    useEffect(() => {
        if (!openDialog) refetch()
    }, [openDialog])

    return (
        <CardCollapse
            title={"Instrumentos"}
            actions={
                permiteEditar &&
                <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                    Nuevo
                </Button>
            }
            colapsable
            tableContent
        >
            <TableList
                entityList={instrumentos}
                columns={columnsTablaWRMInstrumento}
                isLoading={status === QueryStatus.Loading}
                error={status === QueryStatus.Error}
            />
            {
                openDialog &&
                <DialogNuevoInstrumento
                    open={openDialog}
                    setOpen={setOpenDialog}
                    idOperacion={idOperacion}
                />
            }
        </CardCollapse>
    )
}

export default SeccionWRMInstrumento
